import { StarbaseEntity, Serializable } from 'starbase-launcher';
import { Rank } from './rank';
import { IColumnModel, ColumnModel } from 'table-editor';
import { of } from 'rxjs';
import { map } from 'rxjs/operators';
import { Regiment } from './regiment';
import { State } from './state';
import { BranchOfService } from './branchOfService';
import { UnitArmies } from './unitLinking';

export class ImageIndividual extends StarbaseEntity implements Serializable<ImageIndividual> {
  public imageModelId: number;
  public firstName: string;
  public lastName: string;

  public rankId: number;
  public rank: Rank;
  /** Indicates whether the individual is at the rank indicated during the time this image was made. */
  public currentRankInPhoto: boolean;
  public army: UnitArmies; // short army 'Us' or 'Cs'
  public corps: number;
  public regimentNoId: number;
  public regimentNo: Regiment;
  public stateId: number;
  public state: State;
  public branchId: number;
  public branch: BranchOfService;
  public companyLetters: string;
  public notes: string;
  /** Indicates whether this individual is the author of the data on screen.
   * This field should only be available for ImageTypes.Letters type data */
  public author: boolean;

  constructor() {
    super();
  }

  public get fullName(): string {
    return this.firstName + ' ' + this.lastName;
  }

  // eslint-disable-next-line @typescript-eslint/naming-convention
  public static ImageIndividualColumnData(ranks: Rank[]): IColumnModel[] {
    return [
      new ColumnModel('First Name', 'firstName', 'FirstName', true, 'string', false, false, 100, true),
      new ColumnModel('Last Name', 'lastName', 'LastName', true, 'string', false, false, 100, false),
      new ColumnModel('Rank', 'rank', 'Rank', true, 'dropdown', false, false, 100, true, ranks, 'rankDisplay'),
      new ColumnModel('Rank in Photo?', 'currentRankInPhoto', 'CurrentRankInPhoto', true, 'checkbox', false, false, 1, true, null, null),
      new ColumnModel('Co Letters', 'companyLetters', 'CompanyLetters', true, 'string', false, false, 100, true, null, null, 11),
      new ColumnModel('Notes', 'notes', 'Notes', true, 'string', false, false, null, true, null, null)
    ];
  }
  public static setupCollection(collection: ImageIndividual[]): void {
    of(collection).pipe(map(i => i.map(k => {
      k.rank = (k.rank) ? new Rank().deserialize(k.rank) : null;
      k.regimentNo = (k.regimentNo) ? new Regiment().deserialize(k.regimentNo) : null;
      k.state = (k.state) ? new State().deserialize(k.state) : null;
      k.branch = (k.branch) ? new BranchOfService().deserialize(k.branch) : null;
      k['rankDisplay'] = (k.rank) ? k.rank.rankDisplay : '';
    }))).subscribe();
  }

  deserialize(input) {
    input.fullName = undefined;
    delete input.fullName;
    return Object.assign(new ImageIndividual(), input);
  }

  public displayName(): string {
    return (this.firstName + ' ' + this.lastName);
  }
}
